import React, { ChangeEvent, useMemo, useState } from 'react'
import * as datefns from 'date-fns'
import Grid from '@mui/material/Grid'
import { debounce, TextField } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import { useTranslation } from 'react-i18next'

export const CalculateVwapForm = ({
    endDate,
    instrumentId,
    numberOfDays,
    onChange,
}: {
    endDate: Date
    instrumentId: string
    numberOfDays: number
    onChange: (instrumentId: string, endDate: Date, numberOfDays: number) => void
}) => {
    const { t } = useTranslation()
    const [internalNumberOfDays, setInternalNumberOfDays] = useState(numberOfDays)

    const debouncedOnChange = useMemo(() => debounce(onChange, 400), [onChange])

    const handleChangeNumberOfDays = (event: ChangeEvent<HTMLInputElement>) => {
        const days = +(event.target.value || 0)
        setInternalNumberOfDays(days)

        if (!days) return

        debouncedOnChange(instrumentId, endDate, days)
    }

    const handleChangeEndDate = (date: Date | null) => {
        if (!date) return

        onChange(instrumentId, date, numberOfDays)
    }

    return (
        <Grid container spacing={2}>
            <Grid size={6}>
                <TextField
                    type='number'
                    onChange={handleChangeNumberOfDays}
                    label={t('pages.companies.vwap.days')}
                    fullWidth
                    value={internalNumberOfDays}
                    slotProps={{ inputLabel: { shrink: true } }}
                />
            </Grid>
            <Grid size={6}>
                <DatePicker
                    label={t('site.dates.end')}
                    onChange={handleChangeEndDate}
                    value={endDate}
                    maxDate={datefns.subDays(new Date(), 1)}
                />
            </Grid>
        </Grid>
    )
}
